export const FOLLOWERS = 'FOLLOWERS';
export const FOLLOWINGS = 'FOLLOWINGS';
